import React, { FC, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBillingServiceDrawerContent, SCUIBillingAddToListModal } from './components';
import {
    SCUIGeneralDrawer,
    SCUICustomDataGrid,
    SCUITextFieldWithButton,
    SCUIBreadCrumb,
} from '../../../atomic/molecules';
import { BillingCommand } from '../../../services/command';
import { Box, Grid, Tooltip } from '@mui/material';

export const BillingQuery: FC<any> = () => {
    const { t } = useTranslation();

    const [listModalOpen, setListModalOpen] = useState(false);
    const [orderNo, setOrderNo] = useState('');
    const [datas, setDatas] = React.useState<any>();

    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const handleCloseModal = () => {
        setListModalOpen(false);
    };

    const getParams = (documentNo: any) => {
        let params: any = {};
        params.documentNo = documentNo;
        params.getBillingInformationType = 8;
        params.referenceId = 0;
        return params;
    };

    const listele = async () => {
        if (orderNo.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            let tempArr: any = [];
            orderNo
                .trim()
                .split('\n')
                .forEach((item: any, idx: number) => {
                    BillingCommand.PostGetBillingInformation(getParams(item)).then((res: any) => {
                        let my_json = {
                            id: idx,
                            shippmentId: item,
                            result: res.data,
                            error: res.errorMessage ? res.errorMessage : '',
                        };
                        tempArr = [...tempArr, my_json];
                        setDatas(tempArr);
                    });
                });
            handleCloseModal();
        }
    };

    return (
        <SCUIContent>
            <SCUIBillingAddToListModal
                open={listModalOpen}
                onClose={handleCloseModal}
                orderNo={orderNo}
                setOrderNo={setOrderNo}
                listele={listele}
            />
            <SCUIGeneralDrawer
                open={drawerOpen}
                onClose={(_: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setDrawerOpen(false);
                    }
                }}
            >
                <SCUIBillingServiceDrawerContent onClose={onDrawerClose} />
            </SCUIGeneralDrawer>
            <Box className="billing-query">
                <Grid
                    className="billing-query-header"
                    container
                    direction="row"
                    spacing={2}
                    sx={{ marginLeft: '0.5rem' }}
                >
                    <SCUIBreadCrumb title={t('dashboard.billingServiceQuery')} componentLink={'billingQuery'} />
                    <Grid className="billing-query-search-row" size={{ xs: 12 }}>
                        <Box
                            sx={{
                                display: 'inline-flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: { xs: 'stretch', sm: 'center' },
                                justifyContent: 'flex-start',
                                flexWrap: 'nowrap',
                                gap: { xs: 2, sm: 1.5 },
                                width: { xs: '100%', sm: 'auto' },
                                maxWidth: '100%',
                            }}
                        >
                            <Box
                                className="billing-query-billing-no-search"
                                sx={{
                                    flex: '0 0 auto',
                                    minWidth: 0,
                                    width: {
                                        xs: '100%',
                                        sm: 'min(100%, 620px)',
                                        md: 'min(100%, 700px)',
                                        lg: 'min(100%, 780px)',
                                    },
                                }}
                            >
                                <SCUITextFieldWithButton
                                    width="100%"
                                    placeholder={t('billingServiceLog.billingNo')}
                                    onChange={(event: any) => {
                                        setOrderNo(event.target.value);
                                    }}
                                    onClick={() => listele()}
                                    onKeyPress={(e: any) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            listele();
                                        }
                                    }}
                                />
                            </Box>
                            <Box
                                className="billing-query-header-actions"
                                sx={{ flexShrink: 0, alignSelf: { xs: 'flex-start', sm: 'center' } }}
                            >
                                <SCUIButton
                                    className="billing-query-batch-search-button"
                                    text={t('general.batchSearch')}
                                    type="secondary"
                                    sizeType="fixed"
                                    size={'m'}
                                    onClick={() => setListModalOpen(true)}
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                {datas ? (
                    <Grid className="billing-query-results" container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className="billing-query-results-title"
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 9,
                                lg: 9,
                                md: 6,
                                xs: 6,
                            }}
                        >
                            <h1 className="headtxt">{t('general.searchResults')}</h1>
                        </Grid>

                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Box className="billing-query-data-grid" sx={{ width: '100%' }}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={datas}
                                    columns={[
                                        {
                                            field: 'shippmentId',
                                            headerName: t('billingServiceLog.billingNo'),
                                            flex: 1,
                                        },
                                        {
                                            field: 'result',
                                            headerName: t('general.shippingID'),
                                            flex: 1,
                                            headerAlign: 'center',
                                            align: 'center',
                                            renderCell: (params: any) => {
                                                return (
                                                    <div className="billing-query-result-cell">
                                                        <Tooltip title={params.row.result}>
                                                            <a
                                                                target="_blank"
                                                                className="linktxt billing-query-result-link"
                                                                href={
                                                                    '/orderdetail?shippingListId=' + params.row.result
                                                                }
                                                                rel="noreferrer"
                                                            >
                                                                {params.row.result}
                                                            </a>
                                                        </Tooltip>
                                                    </div>
                                                );
                                            },
                                        },
                                        { field: 'error', headerName: '', minWidth: 200, flex: 1 },
                                    ]}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <div className="billing-query-empty-state">
                        <SCUINoRecordComponent />
                    </div>
                )}
            </Box>
        </SCUIContent>
    );
};
